// extracted by mini-css-extract-plugin
export default {"root":"style_root__sQvLG","image":"style_image__1WmAo","loader":"style_loader__yssqZ","processingImage":"style_processingImage__9vpjD","shine":"style_shine__8XcaD"};